export default {
  'center': {
    'common': {
      'search': '查询',
      'reset': '重置',
      'submit': '提交',
      'cancel': '取消',
      'confirm': '确认',
      'operation': '操作',
      'status': '状态',
      'createTime': '创建时间',
      'updateTime': '更新时间',
      'remark': '备注',
      'amount': '金额',
      'currency': '货币',
      'orderNumber': '订单号',
      'memberAccount': '会员账号',
      'fee': '手续费',
      'type': '类型',
      'all': '全部',
      'pending': '待处理',
      'processing': '处理中',
      'completed': '已完成',
      'failed': '失败',
      'rejected': '已拒绝',
      'approved': '已通过',
      'locked': '已锁定',
      'unlocked': '已解锁',
      'dateRange': '日期范围',
      'startDate': '开始日期',
      'endDate': '结束日期',
      'dateType': '日期类型',
      'dateType.createTime': '创建时间',
      'dateType.updateTime': '更新时间',
      'dateType.completeTime': '完成时间',
      'dateType.applyTime': '申请时间',
      'dateType.successTime': '完成时间',
      'noData': '暂无数据',
      'startAmount': '最小金额',
      'endAmount': '最大金额'
    },
    'withdrawal': {
      'title': '提现订单管理',
      'config': {
        'title': '提现配置',
        'basic': {
          'title': '提现基本配置',
          'minAmount': '最小提现金额',
          'maxAmount': '最大提现金额',
          'dailyLimit': '每日提现限额',
          'monthlyLimit': '每月提现限额',
          'feeRate': '手续费率',
          'feeType': '手续费类型',
          'feeTypes': {
            'fixed': '固定金额',
            'percentage': '百分比'
          }
        },
        'risk': {
          'title': '风控配置',
          'ipLimit': 'IP限制',
          'deviceLimit': '设备限制',
          'locationLimit': '地区限制',
          'riskLevel': '风控等级',
          'riskLevels': {
            'low': '低',
            'medium': '中',
            'high': '高'
          }
        }
      },
      'order': {
        'title': '提现订单',
        'status': {
          'pending': '待审核',
          'processing': '处理中',
          'completed': '已完成',
          'failed': '失败',
          'rejected': '已拒绝',
          'waiting': '待出款',
          'paid': '已出款',
          'dfProcessing': '代付处理中',
          'locked': '出款锁定中',
          'riskLocked':'审核锁定中'
        },
        'type': {
          'bank': '银行转账',
          'crypto': '加密货币',
          'other': '其他',
          'BANK': '银行卡',
          'ALIPAY': '支付宝',
          'WECHAT': '微信',
          'USDT': 'USDT'
        },
        'action': {
          'approve': '通过',
          'reject': '拒绝',
          'lock': '锁定',
          'unlock': '解锁',
          'detail': '详情',
          'confirm': '确认出款',
          'paid': '代付出款',
          'rejectWithdraw': '拒绝提现',
          'frontRemark': '前台备注',
          'backRemark': '后台备注',
          'dfFailReason': '代付失败原因',
          'updateChannel': '修改代付渠道',
          'adminUnlock': '管理员解锁'
        },
        'info': {
          'orderNumber': '订单号',
          'memberAccount': '会员账号',
          'currency': '提现币种',
          'amount': '金额信息',
          'withdrawAmount': '提现金额',
          'fee': '手续费',
          'realAmount': '实际到账',
          'withdrawMethod': '提现方式',
          'operationInfo': '操作信息',
          'applyTime': '申请时间',
          'riskCheckTime': '风控审核时间',
          'riskCheckOperator': '风控审核人',
          'successTime': '财务出款时间',
          'successOperator': '出款操作人',
          'channelName': '出款渠道',
          'refuseTime': '财务拒绝时间',
          'refuseOperator': '财务拒绝操作人',
          'timeProgress': '提款时间进度',
          'status': '状态',
          'remark': '备注',
          'manualOperation':'人工出款',
          'withdrawShowInfo':'提款信息',
          'showInfoBankAccount':'银行卡账户名',
          'showInfoBankNumber':'银行卡号',
          'showInfoBankName':'银行卡名称',
          'showInfoUSDTAccount':'USDT地址',
          'showInfoUSDTRate':'USDT汇率',
          'showInfoUSDTType':'USDT链类型',
          'showInfoRealName':'姓名',
          'showInfoAccount':'账号',
          'showInfoRealAmount':'支付金额',
          'showInfoCurSign':'币种',
          'clickCreateOrderTime': '会员点击提款',
          'receiveServerTime': '系统接收请求',
          'financialOperatorTime': '财务操作出款',
          'externalReceiveTime': '三方回调完成',
          'systemGeneratedOrder': '系统生成订单',
        },
        'modal': {
          'reject': {
            'title': '拒绝提现',
            'frontRemark': '前台备注',
            'backRemark': '后台备注',
            'confirm': '确认',
            'cancel': '取消',
            'success': '拒绝成功',
            'failed': '拒绝失败'
          },
          'confirm': {
            'title': '确认出款',
            'content': '确定要确认出款吗？',
            'confirm': '确认',
            'cancel': '取消',
            'success': '确认出款成功',
            'failed': '确认出款失败',
            '70016015':'金额不满足渠道最小金额',
            '70016016':'金额超过渠道最大金额',
            '70018018':'渠道参数配置异常，请检查',
            '70015065':'该提款订单代付失败，请尝试其他代付渠道',
            '70015073':'该条记录正在操作中，请勿重复操作',
            '70015017':'代付出款需要会员进行真实姓名认证',
            '70015076':'请检查最新的订单状态',
          },
          'paid': {
            'title': '代付出款',
            'channel': '代付渠道',
            'selectChannel': '请选择代付渠道',
            'confirm': '确认',
            'cancel': '取消',
            'success': '代付出款成功',
            'failed': '代付出款失败'
          },
          'remark': {
            'title': '备注信息',
            'frontRemark': '前台备注',
            'backRemark': '后台备注',
            'close': '关闭'
          },
          'updateChannel': {
            'title': '修改代付渠道',
            'channel': '代付渠道',
            'selectChannel': '请选择代付渠道',
            'confirm': '确认',
            'cancel': '取消',
            'success': '修改代付渠道成功',
            'failed': '修改代付渠道失败'
          }
        }
      }
    },
    'recharge': {
      'title': '充值订单管理',
      'config': {
        'title': '充值配置',
        'channel': {
          'title': '充值渠道配置',
          'name': '渠道名称',
          'currency': '货币种类',
          'platform': '平台类型',
          'status': '状态',
          'statuses': {
            'enabled': '启用',
            'disabled': '禁用'
          }
        }
      },
      'order': {
        'title': '充值订单',
        'info': {
          'orderNumber': '订单号',
          'memberAccount': '会员账号',
          'paymentChanneName':'渠道名称',
          'currency': '充值币种',
          'amount': '充值金额',
          'fee': '手续费',
          'realAmount': '实际到账',
          'status': '订单状态',
          'createTime': '创建时间',
          'payTime': '支付时间',
          'orderSource': '订单来源',
          'platform': '充值方式',
          'dateType': '日期类型',
          'dateRange': '时间范围',
          'startDate': '开始日期',
          'endDate': '结束日期',
          'paymentMethod': '支付方式',
          'successTime': '成功时间',
          'successOperator':'操作人',
          'timeInfo': '时间信息',
          'showOvertimeOnly': '仅显示超时订单',
          'memberOrderTime': '会员下单时间',
          'paymentSuccessTime': '支付成功时间',
          'timeDetails': {
            't0': 'T0 点击下单',
            't1': 'T1 下单请求',
            't2': 'T2 生成订单',
            't3': 'T3 三方返回',
            't3_5': 'T3.5 返回前端',
            't4': 'T4 跳转支付',
            't5': 'T5 回调响应',
            'memberPaying': '🟡 会员未跳转支付',
            'paymentTimeout': '🔴 支付拉起链路超时: T3.5-T0 = {time}',
            'expandFullLink': '展开全链路',
            'collapseFullLink': '收起全链路'
          },
        },
        'source': {
          'H5': 'H5',
          'IOS': 'IOS',
          'ANDROID': 'ANDROID'
        },
        'status': {
          'pending': '待支付',
          'processing': '处理中',
          'completed': '已完成',
          'failed': '失败',
          'rejected': '已拒绝',
          'waiting': '待确认',
          'paid': '已支付',
          'dfProcessing': '代付处理中',
          'locked': '已锁定',
          'expired':'已过期',
          'invalid':'无效'
        },
        'action': {
          'confirm': '确认订单',
          'approve': '通过',
          'reject': '拒绝',
          'detail': '详情',
          'export': '导出'
        },
        'modal': {
          'approve': {
            'title': '通过充值订单',
            'remark': '备注'
          },
          'reject': {
            'title': '拒绝充值订单',
            'reason': '拒绝原因',
            'remark': '备注'
          },
          'confirm': {
            'title': '确认充值订单',
            'content': '确认该充值订单已到账?',
            'confirm': '确认',
            'cancel': '取消'
          }
        }
      }
    },
    'payment': {
      'title': '支付设置',
      'channel': {
        'title': '支付渠道设置',
        'name': '渠道名称',
        'code': '渠道代码',
        'type': '渠道类型',
        'status': '状态',
        'config': '配置信息',
        'action': {
          'add': '添加渠道',
          'edit': '编辑渠道',
          'delete': '删除渠道',
          'enable': '启用',
          'disable': '禁用'
        }
      }
    },
    // 回调白名单
    callbackWhitelist: {
      title: '回调白名单',
      type: {
        label: '类型',
        placeholder: '请选择类型',
        all: '全部',
        pay: '支付',
        withdraw: '提款'
      },
      component: {
        label: '渠道名称',
        placeholder: '请输入渠道名称'
      },
      ip: {
        label: 'IP地址',
        placeholder: '请输入IP地址',
        formatError: '请输入有效的IP地址格式',
        example: '请输入IP地址，例如：192.168.1.1'
      },
      createTime: '创建时间',
      createUser: '创建人',
      action: {
        search: '查询',
        reset: '重置',
        add: '添加白名单IP',
        delete: '删除',
        deleteConfirm: '确定要删除这条白名单记录吗？',
        deleteSuccess: '删除成功',
        deleteFailed: '删除失败',
        addSuccess: '添加成功',
        addFailed: '添加失败'
      },
      modal: {
        addTitle: '添加白名单IP',
        type: {
          label: '类型',
          placeholder: '请选择类型',
          required: '请选择类型'
        },
        component: {
          label: '渠道选择',
          placeholder: '请选择渠道',
          required: '请选择渠道'
        },
        ip: {
          label: 'IP地址',
          placeholder: '请输入IP地址，例如：192.168.1.1',
          required: '请输入IP地址',
          formatError: '请输入有效的IP地址格式'
        },
        confirm: '确认',
        cancel: '取消'
      }
    },
    paymentSettings: {
      title: '支付设置',
      channel: {
        title: '支付渠道',
        search: {
          channelName: '渠道名称',
          channelNamePlaceholder: '请输入渠道名称',
          paymentGroup: '支付分组',
          paymentGroupPlaceholder: '请选择支付分组',
          paymentModel: '支付方式',
          paymentModelPlaceholder: '请选择支付方式',
          currency: '货币类型',
          currencyPlaceholder: '请选择货币类型',
          status: '状态',
          statusPlaceholder: '请选择状态',
          statusEnabled: '启用',
          statusDisabled: '禁用',
          search: '搜索',
          button: '搜索',
          reset: '重置'
        },
        table: {
          channelName: '渠道名称',
          paymentGroup: '支付分组',
          paymentModel: '支付方式',
          payDescription: '渠道描述',
          currency: '货币种类',
          platformType: '平台类型',
          minAmount: '最小金额',
          maxAmount: '最大金额',
          amountRange:'金额范围',
          agentOverride: '代理覆盖',
          default: '默认',
          memberLevel:'会员等级',
          agentConfig: '代理配置',
          agentConfigNotSet: '未配置',
          agentConfigAll: '全部代理',
          agentConfigPartial: '个别代理',
          agentConfigSet: '已配置',
          agentConfigOverride: '代理覆盖 · 金额规则',
          agentConfigNote: '其他代理/普通用户：按全局配置；优先级：代理配置 > 全局配置。',
          status: '状态',
          sort:'排序',
          action: '操作',
          edit: '编辑',
          params: '参数',
          delete: '删除'
        },
        modal: {
          add: '新增支付渠道',
          edit: '编辑支付渠道',
          delete: {
            title: '确认删除',
            content: '确定要删除该支付渠道吗？'
          }
        },
        form: {
          paymentGroup: '支付分组',
          paymentGroupPlaceholder: '请选择支付分组',
          paymentGroupAll:'全部',
          paymentGroupOnline:'线上支付',
          paymentGroupOffline:'线下支付',
          paymentModel: '支付方式',
          paymentModelPlaceholder: '请选择支付方式',
          channel: '渠道选择',
          channelPlaceholder: '请选择渠道',
          channelName:'渠道名称',
          channelNamePlaceholder:'请输入渠道名称',
          currency: '货币种类',
          currencyPlaceholder: '请选择货币种类',
          platformType: '平台类型',
          platformTypePlaceholder: '请选择平台类型',
          paymentPlatformAll:'全部',
          paymentPlatformPC:'PC端',
          paymentPlatformH5:'H5端',
          minAmount: '最小金额',
          minAmountPlaceholder: '请输入最小金额',
          maxAmount: '最大金额',
          maxAmountPlaceholder: '请输入最大金额',
          depositStairs:'累计条件',
          depositStairsPlaceholder:'请输入累计存款条件',
          amountType:'金额类型',
          amountTypePlaceholder:'请选择金额类型',
          amountTypeSelect:'固定金额',
          amountTypeWrite:'填写金额',
          amountTypeAll:'全部支持',
          amountList:'金额列表',
          amountListPlaceholder:'请输入金额列表，逗号分隔',
          defaultAmount: '默认金额',
          defaultAmountPlaceholder: '请输入默认金额',
          amountListInRangeError: '金额列表中的数值必须在最小金额和最大金额之间',
          defaultAmountInListError: '固定金额时，默认金额必须包含在金额列表中',
          memberLevel:'会员等级',
          memberLevelPlaceholder:'请选择会员等级',
          memberLevelAll:'全部等级',
          walletAccount: '钱包账号',
          walletAccountPlaceholder: '请输入钱包账号',
          walletName: '钱包用户名',
          walletNamePlaceholder: '请输入钱包用户名',
          payTag:'备注信息',
          payTagPlaceholder:'请输入备注信息',
          payDescription: '渠道描述',
          payDescriptionPlaceholder:'请输入渠道描述',
          sort:'排序',
          sortPlaceholder:'请输入排序',
          needMemberName:'是否需要真实姓名',
          needMemberName1:'是',
          needMemberName2:'否',
          usdtAccount:'USDT地址',
          usdtAccountPlaceholder:'请输入USDT地址',
          usdtType:'USDT类型',
          usdtTypePlaceholder:'请选择USDT类型',
          usdtRate: 'USDT汇率',
          usdtRatePlaceholder: '请输入USDT汇率',
          usdtRateType: 'USDT汇率类型',
          usdtRateTypeFixed: '固定汇率',
          usdtRateTypeFloat: '浮动汇率',
          bankName: '银行名称',
          bankNamePlaceholder: '请输入银行名称',
          bankAccount: '银行卡账户',
          bankAccountPlaceholder: '请输入银行卡账户',
          bankNumber:'银行卡号',
          bankNumberPlaceholder:'请输入银行卡号',
          bankAddress: '银行地址',
          bankAddressPlaceholder: '请输入银行地址',
          accountName: '账户名称',
          accountNamePlaceholder: '请输入账户名称',
          qrCode: '二维码',
          qrCodeUpload: '上传二维码',
          qrCodeTip: '请上传二维码图片',
          agentSelect: '代理选择（可搜索 · 多选）',
          agentSearchPlaceholder: '搜索代理账号…',
          allAgents: '全部代理',
          unknown: '未知',
          agentConfig: '代理配置（覆盖全局金额）',
          agentConfigNote: '（默认收起，仅在需要时配置）',
          agentConfigValidation: '校验：最小 ≤ 最大；默认金额需在区间内；固定金额时"默认金额"必须包含在金额列表；金额列表数值需在区间内。',
          agentConfigDisabled: '代理配置已关闭，请开启开关以配置代理规则',
          status: '状态',
          // 代理配置验证消息
          agentSelectRequired: '请选择代理',
          loading: '加载中...',
          noData: '暂无数据',
          minAmountRequired: '最小金额不能为空',
          maxAmountRequired: '最大金额不能为空',
          minAmountError: '最小金额必须小于最大金额',
          maxAmountError: '最大金额必须大于最小金额',
          defaultAmountError: '默认金额必须在最小金额和最大金额之间',
          amountListRequired: '金额类型为固定金额时，必须填写金额列表',
          // 通用消息
          missingDataId: '缺少必要的数据标识，无法更新记录',
          updateSuccess: '更新成功',
          addSuccess: '添加成功',
          updateFailed: '更新失败',
          addFailed: '添加失败',
          formValidationFailed: '表单验证失败',
          formValidationFailedCheck: '表单验证失败，请检查输入内容',
          operationFailed: '操作失败，请重试',
          fetchAgentListFailed: '获取代理列表失败'
        },
        param: {
          title: '参数配置',
          merchantId: '商户ID',
          merchantKey: '商户密钥',
          apiUrl: 'API地址',
          notifyUrl: '通知地址',
          remark: '备注',
          alipayAppId: '支付宝AppID',
          alipayPrivateKey: '支付宝私钥',
          alipayPublicKey: '支付宝公钥',
          wxAppId: '微信AppID',
          wxMchId: '微信商户号',
          wxApiKey: '微信API密钥',
          gatewayUrl: '网关地址',
          returnUrl: '返回地址',
          signType: '签名类型',
          version: '版本号',
          required: '请输入必填项',
          fetchError: '获取参数列表失败',
          saveSuccess: '保存成功',
          saveError: '保存失败'
        }
      },
      method: {
        title: '支付方式',
        search: {
          paymentMethodName: '支付方式名称',
          paymentMethodNamePlaceholder: '请输入支付方式名称',
          curSign: '货币类型',
          curSignPlaceholder: '请选择货币类型',
          paymentType: '支付类型',
          paymentTypePlaceholder: '请选择支付类型',
          status: '状态',
          statusPlaceholder: '请选择状态',
          statusAll: '全部',
          statusEnabled: '启用',
          statusDisabled: '禁用',
          button: '查询',
          reset: '重置'
        },
        table: {
          paymentGroup: '支付分组',
          paymentModel: '支付方式',
          currency: '货币类型',
          platformType: '平台类型',
          platformTypeAll: '全部',
          platformTypePC: 'PC',
          platformTypeH5: 'H5',
          logo: '图标Logo',
          sort: '排序',
          status: '状态',
          action: '操作',
          edit: '编辑',
          delete: '删除'
        },
        modal: {
          add: '新增支付方式',
          edit: '编辑支付方式',
          delete: {
            title: '确认删除',
            content: '确定要删除这个支付方式吗？'
          },
          success: {
            create: '创建成功',
            update: '更新成功',
            createFailed: '创建失败',
            updateFailed: '更新失败'
          }
        },
        form: {
          basicInfo: '基本信息',
          paymentGroup: '支付分组',
          paymentGroupPlaceholder: '请选择支付分组',
          paymentGroupAll: '全部分组',
          paymentGroupOnline: '线上支付',
          paymentGroupOffline: '线下支付',
          currency: '币种',
          currencyPlaceholder: '请选择币种',
          paymentModel: '支付方式',
          paymentModelPlaceholder: '请选择支付方式',
          paymentModelName: '支付方式名称',
          paymentModelNamePlaceholder: '请输入支付方式名称',
          paymentShowName:'支付方式展示名称',
          paymentShowNamePlaceholder:'请输入支付方式展示名称',
          payTag:'支付方式标签',
          payTagPlaceholder:'请输入支付方式标签',
          platformType: '平台类型',
          platformTypePlaceholder: '请选择平台类型',
          platformTypeAll: '全部',
          platformTypePC: 'PC',
          platformTypeH5: 'H5',
          sort: '排序',
          sortPlaceholder: '请输入排序',
          iconSettings: '图标设置',
          pcLogo: 'PC端Logo',
          h5Logo: 'H5端Logo',
          otherInfo: '其他信息',
          remark: '备注',
          remarkPlaceholder: '请输入备注',
          confirm: '确定',
          cancel: '取消',
          defaultPlaceholder: '请选择'
        },
        error: {
          unknownType: '未知的选择类型:',
          fetchOptionsFailed: '获取{type}选项失败:'
        }
      }
    },
    'withdrawalSettings': {
      'withdrawalMethod': {
        'title': '提现方式设置',
        'search': {
          'searchKeyword': '类型名称',
          'searchKeywordPlaceholder': '请输入类型名称',
          'status': '状态',
          'statusPlaceholder': '请选择状态',
          'statusAll': '全部',
          'statusEnabled': '启用',
          'statusDisabled': '禁用',
          'curSign': '币种',
          'curSignPlaceholder': '请选择币种',
          'button': '搜索',
          'reset': '重置'
        },
        'table': {
          'typeName': '类型名称',
          'showName': '显示名称',
          'showRemark': '前台提示',
          'logoPic':'展示图标',
          'logoPicPC':'PC端图标',
          'logoPicH5':'H5端图标',
          'amountRange':'金额范围',
          'curSign': '提现币种',
          'minAmount': '最小金额',
          'maxAmount': '最大金额',
          'overAmount': '超额金额',
          'fee': '手续费',
          'sort': '排序',
          'status': '状态',
          'updateInfo': '更新信息',
          'action': '操作'
        },
        'modal': {
          'add': '添加提现方式',
          'edit': '编辑提现方式',
          'delete': {
            'title': '确认删除',
            'content': '确定要删除这个提现方式吗？'
          }
        },
        'form': {
          'typeName': '类型名称',
          'typeNamePlaceholder': '请输入类型名称',
          'showName': '显示名称',
          'showNamePlaceholder': '请输入显示名称',
          'showRemark': '前台提示',
          'showRemarkPlaceholder': '请输入前台提示',
          'curSign': '币种',
          'curSignPlaceholder': '请选择币种',
          'minAmount': '最小金额',
          'minAmountPlaceholder': '请输入最小金额',
          'maxAmount': '最大金额',
          'maxAmountPlaceholder': '请输入最大金额',
          'overAmount': '超额金额',
          'overAmountPlaceholder': '请输入超额金额',
          'fee': '手续费',
          'feePlaceholder': '请输入手续费',
          'sort': '排序',
          'sortPlaceholder': '请输入排序',
          'pcImg': 'PC端图标',
          'h5Img': 'H5端图标',
          'amountType': '金额类型',
          'amountTypePlaceholder': '请选择金额类型',
          'amountTypeAll': '全部支持',
          'amountTypeFixed': '固定金额',
          'amountTypeInput': '填写金额',
          'amountList': '金额列表',
          'amountListPlaceholder': '请输入金额列表，如：100,200,500,1000',
          'amountListTooltip': '多个金额用英文逗号分隔，如：100,200,500,1000',
          'defaultAmount': '默认金额',
          'defaultAmountPlaceholder': '请输入默认金额',
          'amountListFormatError': '格式错误，请使用纯数字且以英文逗号分隔，如: 100,200,500',
          'defaultAmountInListError': '固定金额时，默认金额必须包含在金额列表中'
        },
        'message': {
          'fetchFailed': '获取数据失败',
          'addSuccess': '添加成功',
          'addFailed': '添加失败',
          'editSuccess': '编辑成功',
          'editFailed': '编辑失败',
          'deleteSuccess': '删除成功',
          'deleteFailed': '删除失败',
          'enableSuccess': '启用成功',
          'enableFailed': '启用失败',
          'disableSuccess': '禁用成功',
          'disableFailed': '禁用失败'
        },
        'button': {
          'edit': '编辑',
          'delete': '删除'
        }
      },
      'bankSettings': {
        'title': '银行设置',
        'search': {
          'bankShortName': '银行简称',
          'bankShortNamePlaceholder': '例如：BPI / BDO',
          'bankFullName': '银行全称',
          'bankFullNamePlaceholder': '例如：Bank of the Philippine Islands',
          'curSign': '币种',
          'curSignPlaceholder': '请选择币种',
          'status': '状态',
          'statusPlaceholder': '请选择状态',
          'button': '搜索',
          'reset': '重置'
        },
        'table': {
          'bankShortName': '银行简称',
          'bankFullName': '银行全称',
          'curSign': '币种',
          'status': '状态',
          'action': '操作'
        },
        'button': {
          'add': '添加',
          'edit': '编辑',
          'delete': '删除',
          'channelMapping': '渠道映射配置'
        },
        'form': {
          'bankShortName': '银行简称',
          'bankShortNamePlaceholder': '请输入银行简称',
          'bankFullName': '银行全称',
          'bankFullNamePlaceholder': '请输入银行全称',
          'curSign': '币种',
          'curSignPlaceholder': '请选择币种'
        },
        'modal': {
          'add': '添加银行信息',
          'edit': '编辑银行信息',
          'delete': {
            'title': '确认删除',
            'content': '确定要删除这条银行信息吗？'
          },
          'channelMapping': '渠道映射配置'
        },
        'message': {
          'fetchFailed': '获取数据失败',
          'createSuccess': '创建成功',
          'createFailed': '创建失败',
          'updateSuccess': '更新成功',
          'updateFailed': '更新失败',
          'deleteSuccess': '删除成功',
          'deleteFailed': '删除失败',
          'enableSuccess': '启用成功',
          'enableFailed': '启用失败',
          'disableSuccess': '禁用成功',
          'disableFailed': '禁用失败',
          'operationFailed': '操作失败，请重试',
          'channelMappingComingSoon': '渠道映射配置功能开发中',
          'fetchChannelMappingFailed': '获取渠道映射配置失败',
          'channelMappingSaveSuccess': '渠道映射配置保存成功',
          'channelMappingSaveFailed': '渠道映射配置保存失败',
          'bankInfoIdRequired': '银行信息ID不能为空',
          '70023003': '银行简称已存在，不能添加相同的银行简称',
          '70023004': '银行全称已存在，不能添加相同的银行全称',
          '70023005': '银行名称已存在，不能添加相同的银行名称'
        },
        'channelMapping': {
          'paymentChannel': '代付渠道',
          'channelName': '渠道名称',
          'bankCode': '代付代码 (传给渠道的 BankCode)',
          'bankCodePlaceholder': '例如: PH_AUB / 161319 / BC00007',
          'notSupported': '（不支持该渠道）',
          'description': '说明:系统代付时,将根据「银行简称+代付渠道」查找这里配置的代付代码,并传递给三方渠道。bankCode 为空则视为不支持该渠道。'
        }
      },
      'paidChannel': {
        'title': '代付渠道设置',
        'search': {
          'channelName': '渠道名称',
          'channelNamePlaceholder': '请输入渠道名称',
          'channelType': '渠道类型',
          'channelTypePlaceholder': '请选择渠道类型',
          'curSign': '货币',
          'curSignPlaceholder': '请选择货币',
          'status': '状态',
          'statusPlaceholder': '请选择状态',
          'statusAll': '全部',
          'statusEnabled': '启用',
          'statusDisabled': '禁用',
          'button': '搜索',
          'reset': '重置'
        },
        'table': {
          'channelName': '渠道名称',
          'componentName': '代付渠道',
          'channelType': '提款方式',
          'curSign': '货币类型',
          'minAmount': '最小金额',
          'maxAmount': '最大金额',
          'fee': '手续费',
          'status': '状态',
          'updateInfo': '更新信息',
          'action': '操作'
        },
        'modal': {
          'add': '添加代付渠道',
          'edit': '编辑代付渠道',
          'delete': {
            'title': '确认删除',
            'content': '确定要删除这个代付渠道吗？'
          },
          'param': {
            'title': '{{channelName}} 参数配置',
            'cancel': '取消',
            'save': '保存',
            'noParams': '暂无参数配置',
            'inputPlaceholder': '请输入{{key}}'
          }
        },
        'form': {
          'channelName': '渠道名称',
          'channelNamePlaceholder': '请输入渠道名称',
          'componentName': '组件名称',
          'componentNamePlaceholder': '请选择组件',
          'channelType': '渠道类型',
          'channelTypePlaceholder': '请选择渠道类型',
          'curSign': '货币',
          'curSignPlaceholder': '请选择货币',
          'minAmount': '最小金额',
          'minAmountPlaceholder': '请输入最小金额',
          'maxAmount': '最大金额',
          'maxAmountPlaceholder': '请输入最大金额',
          'fee': '手续费',
          'feePlaceholder': '请输入手续费'
        },
        'message': {
          'fetchFailed': '获取数据失败',
          'addSuccess': '添加成功',
          'addFailed': '添加失败',
          'editSuccess': '编辑成功',
          'editFailed': '编辑失败',
          'deleteSuccess': '删除成功',
          'deleteFailed': '删除失败',
          'enableSuccess': '启用成功',
          'enableFailed': '启用失败',
          'disableSuccess': '禁用成功',
          'disableFailed': '禁用失败',
          'paramSaveSuccess': '参数保存成功',
          'paramSaveFailed': '参数保存失败'
        },
        'button': {
          'add': '添加',
          'edit': '编辑',
          'delete': '删除',
          'param': '参数'
        }
      }
    },
    riskWithdrawConfig: {
      title: '风控提现配置',
      section: {
        currencyConfig: '币种配置'
      },
      status: {
        enabled: '启用',
        disabled: '禁用'
      },
      button: {
        save: '保存'
      },
      input: {
        placeholder: '请输入阈值'
      },
      message: {
        fetchFailed: '获取配置列表失败',
        editSuccess: '保存成功',
        editFailed: '保存失败'
      },
      configGroup: {
        netAmount: '总充提差(固定金额)',
        netPercent:'总充提差(百分比)',
        winLost: '用户输赢',
        withdrawAmount: '当次提款金额',
        bonusPercent: '总优惠占比',
        bonusAmount:'总优惠金额',
        riskModel: '风控模式',
        riskRule: '提款金额规则',
        bonusSection: '优惠获取情况',
        arbitrageSection: '游戏套利风控'
      },
      sectionTitle: {
        netDiff: '1) 充提差（固定金额 + 百分比）',
        userWinLost: '1.2 用户输赢（可选）',
        withdrawAmountRule: '1.3 提款金额规则（VIP 等级区间可配置，VIP0=非会员）',
        bonus: '2) 优惠获取情况（独立规则）',
        arbitrage: '3) 游戏套利风控（命中→人工审核）',
        noDeposit: '0存款用户疑似套利（高风险游戏盈利占比过高）',
        initDeposit: '首存阶段疑似套利（余额/存款倍数异常）',
        deviceIP: '同设备/同IP多账号疑似套利'
      },
      riskRuleFields: {
        vipMin: 'VIP最小值',
        vipMax: 'VIP最大值',
        successWithdraw: '提现成功订单数=0',
        successWithdrawStatus: '状态',
        successTopUp: '充值成功订单数=0',
        successTopUpStatus: '状态',
        successDeposit: '充值成功订单数>0',
        successDepositStatus: '状态',
        totalX: '当日累计阈值 X',
        totalY: '当日累计阈值 Y',
        totalZ: '当日累计阈值 Z'
      },
      arbitrageFields: {
        balance: '余额',
        profitRisk: '高风险游戏盈利占比',
        deposit: '投注金额',
        historyNum: '历史存款次数',
        balanceDepositMul: '余额/存款倍数',
        depoistStart: '存款次数区间起',
        depoistEnd: '存款次数区间止',
        deviceStart: '注册设备数区间起',
        deviceEnd: '注册设备数区间止',
        iPStart: '注册IP数区间起',
        iPEnd: '注册IP数区间止'
      },
      riskModel: {
        auto: '自动审核',
        manual: '人工审核'
      },
      globeStatus: {
        enabled: '启用',
        disabled: '禁用'
      },
      descriptions: {
        netAmount: '总充提差=总提款 - 总存款<br/>充提差百分比 = 总提款 / 总存款 * 100%<br/>当前用户的充提差数据大于设置的值，且两者同时满足条件，将进入人工审批',
        netPercent: '总充提差=总提款 - 总存款<br/>充提差百分比 = 总提款 / 总存款 * 100%<br/>当前用户的充提差数据大于设置的值，且两者同时满足条件，将进入人工审批',
        winLost: '用户输赢 = 用户累计输赢，若为正，表示用户盈利。<br/>当用户的输赢超出设置的值时，将进入人工审核。',
        withdrawAmount: '当次提款金额 = 本次提款金额的绝对数值，当前用户的提款金额大于设置的值时，进入人工审核',
        bonusPercent: '总优惠占比 = 总领取优惠 / 总存款金额 * 100%<br/>优惠总额 = 领取优惠的绝对数值<br/>当前用户的优惠总额的绝对值大于设置的值，且两者同时满足条件，将进入人工审核',
        bonusAmount: '总优惠占比 = 总领取优惠 / 总存款金额 * 100%<br/>优惠总额 = 领取优惠的绝对数值<br/>当前用户的优惠总额的绝对值大于设置的值，且两者同时满足条件，将进入人工审核',
        riskModel: ''
      },
      addRange: '新增区间',
      delete: '删除',
      ruleHitDesc: '命中任一启用规则 → 提现进入【人工审核】。',
      hintPrefix: '提示：',
      autoHintDescBody: '命中以下任意规则的提款订单将进入【人工审核】；未命中则按自动审核流程处理。',
      autoHintDesc: '提示：命中以下任意规则的提款订单将进入【人工审核】；未命中则按自动审核流程处理。',
      balanceCalPrefix: '风控核算余额（提现风控口径）：',
      balanceCalBody: '账户余额 + 本次提现金额 + 正在审核中的提现订单金额 + 未结算订单投注金额。',
      balanceCalDesc: '风控核算余额（提现风控口径）：账户余额 + 本次提现金额 + 正在审核中的提现订单金额 + 未结算订单投注金额。',
      hitRuleTitle: '1) 提款命中规则',
      tableRuleName: '规则名称（中文）',
      tableCondition: '条件',
      tableThreshold: '阈值',
      tableStatus: '状态',
      tableConfig: '配置项',
      netDiffCondition: '总充提差 = 总提款 - 总存款 ≥ 固定阈值；且 充提差百分比 =（总提款 / 总存款）× 100% ≥ 百分比阈值（当两项同时启用时）',
      netDiffRowName: '总充提差（固定金额 / 百分比）',
      fixedAmountLabel: '固定金额 ≥',
      percentLabel: '百分比 ≥',
      winLostRowName: '用户累计输赢达到阈值',
      winLostCondition: '用户累计输赢（或净输赢）达到阈值',
      bonusRowName: '优惠获取异常（占比 / 金额）',
      bonusCondition: '总优惠占比 =（总领取优惠 / 总存款金额）× 100%；优惠总额 = 领取优惠绝对值；两者同时 ≥ 阈值',
      bonusPercentLabel: '总优惠占比 ≥',
      bonusAmountLabel: '总优惠金额 ≥',
      vipRangeHint: '区间规则：vip_min ≤ VIP等级 ≤ vip_max；区间不重叠；按 vip_min 升序。（示例：0-0 非会员；1-3 / 4-6 / 7-10）',
      noHistoryWithdraw: '无历史提现',
      noHistoryDeposit: '无历史充值',
      hasDepositRecord: '有充值记录',
      dailyThresholdXYZ: '当日累计阈值（X/Y/Z）',
      noDepositMuted: '历史存款次数=0；净赢任一为负不触发。',
      deviceIPMuted: '区间支持 0-0 表示不限制；Y ≥ X。',
      sectionTitleNetDiffSub: '1.1 充提差（固定金额 + 百分比）',
      sectionTitleUserWinLostSub: '1.2 用户输赢（可选）',
      sectionTitleWithdrawAmountRuleSub: '1.3 提款金额规则（VIP 等级区间可配置，VIP0=非会员）',
      sectionTitleBonusSub: '2) 优惠获取情况（独立规则）',
      sectionTitleArbitrageSub: '3) 游戏套利风控（命中→人工审核）',
      netDiffRuleDef: '规则定义：<b>总充提差 = 总提款 - 总存款</b>；<b>充提差百分比 =（总提款 / 总存款）× 100%</b>。<br />',
      netDiffHitLogic: '命中逻辑：当前用户的充提差数据 <b>大于/等于</b> 设置阈值，且当固定金额与百分比同时启用时，需 <b>两者同时满足（AND）</b> 才命中并进入人工审核。',
      statusEnabled: '启用',
      statusOpen: '开启',
      operation: '操作',
      vipRangeIntro: '统一用"VIP 等级区间"配置：',
      vipRangeIntroBold: 'vip_min=0 且 vip_max=0 即非会员（原非VIP）。',
      riskRuleHitDesc: '命中"所在区间"内任一【已启用】条件（OR）→ 人工审核。',
      vipRangeLabel: 'VIP 等级区间',
      singleWithdrawThreshold: '单笔提款金额阈值（X）',
      bonusRuleDef: '规则定义：',
      bonusRuleDefPart1: '<b>总优惠占比 =（总领取优惠 / 总存款金额）× 100%</b>；',
      bonusRuleDefPart2: '<b>优惠总额 = 领取优惠的绝对数值</b>。<br />',
      bonusHitLogic: '命中逻辑：当前用户的优惠总额（绝对值）与总优惠占比均 <b>大于/等于</b> 设置阈值，且两者同时满足（AND）时进入人工审核。',
      tableNote: '说明',
      depositRange: '存款次数区间',
      deviceRange: '注册设备数区间',
      ipRange: '注册IP数区间',
      balanceGt: '风控核算余额 >',
      profitRiskGt: '高风险游戏盈利占比 >',
      depositLt: '投注金额 <',
      historyNumLt: '历史存款次数 <',
      balanceDepositMulGt: '风控核算余额/存款倍数 >',
      saveConfig: '保存配置'
    }
  },

  // Add manualBalance translations
  'manualBalance': {
    'title': '会员调账记录',
    'dateRange': '调账时间',
    'startDate': '开始日期',
    'endDate': '结束日期',
    'dateRangeExceeded': '查询时间范围不能超过 {days} 天',
    'memberAccount': '会员账号',
    'enterMemberAccount': '请输入会员账号',
    'transNo': '订单号',
    'enterTransNo': '请输入订单号',
    'subType': '调账类型',
    'selectSubType': '请选择调账类型',
    'manualIn': '人工存入',
    'manualOut': '人工转出',
    'manualInNotIncludeOrder': '人工存入 不计存款订单',
    'manualOutNotIncludeOrder': '人工转出 不计提款订单',
    'badDebtOrder': '挂账清偿',
    'agentIn': '代理存入',
    'agentOut': '代理转出',
    'curSign': '币种',
    'selectCurrency': '请选择币种',
    'search': '查询',
    'reset': '重置',
    'agentLine': '代理线',
    'unknownType': '未知类型',
    'amount': '调账金额',
    'method': '方式',
    'included': '已计入存提',
    'notIncluded': '未计入',
    'remark': '备注',
    'beforeAmount': '调账前余额',
    'afterAmount': '调账后余额',
    'externalBetflow': '流水金额',
    'createUser': '调账人',
    'enterCreateUser': '请输入调账人',
    'export': '导出',
    'exportLoading': '正在生成导出文件，请稍候...',
    'exportSuccess': '导出任务已提交，请在下载列表中查看',
    'createUserAndTime': '调账人/调账时间',
    'totalCount': '总笔数',
    'totalAmount': '总金额'
  }
};
